import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/locations', request, cancelToken)
}

export {get}
